// src/lib/utils/date.ts
// All timestamps render in Africa/Johannesburg. en-ZA locale to match formatRand.

const SAST = 'Africa/Johannesburg';

export const formatSAST = (iso: string): string =>
  new Date(iso).toLocaleString('en-ZA', { timeZone: SAST });

export const formatSASTShort = (iso: string): string =>
  new Date(iso).toLocaleString('en-ZA', {
    timeZone: SAST,
    day: '2-digit',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });

export const formatSASTTime = (iso: string): string =>
  new Date(iso).toLocaleTimeString('en-ZA', {
    timeZone: SAST,
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });

export const formatSASTDate = (iso: string): string =>
  new Date(iso).toLocaleDateString('en-ZA', {
    timeZone: SAST,
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });

export const relativeFromNow = (iso: string, nowMs: number = Date.now()): string => {
  const diff = nowMs - new Date(iso).getTime();
  const min = 60 * 1000;
  const hr = 60 * min;
  const day = 24 * hr;
  if (diff < min) return 'just now';
  if (diff < hr) return `${Math.floor(diff / min)}m ago`;
  if (diff < day) return `${Math.floor(diff / hr)}h ago`;
  return `${Math.floor(diff / day)}d ago`;
};
